module.exports = __webpack_public_path__ + "static/media/it-bag.017f1920.svg";